<template>
  <div class="js-basedata-faultcode app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('feedback.search.width1')">
              <el-form-item :label="$t('feedback.mobile')+'：'">
                <el-input v-model="listQuery.mobile" filterable clearable :placeholder="$t('feedback.mobile')" />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('feedback.search.width2')">
              <el-form-item :label="$t('feedback.replayStatus')+'：'">
                <el-select v-model="listQuery.feedbackReplied" filterable clearable :placeholder="$t('feedback.replayStatus')">
                  <el-option v-for="(item,index) in feedbackRepliedList" :key="index" :label="item.text" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('feedback.search.width2')">
              <el-form-item :label="$t('feedback.processStatus')+'：'">
                <el-select v-model="listQuery.feedbackStatus" filterable clearable :placeholder="$t('feedback.processStatus')">
                  <el-option v-for="(item,index) in feedbackStatusList" :key="index" :label="item.text" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-show="collapse" style="margin-top:10px" :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="12">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('feedback.search.width3')"
            >
              <el-form-item :label="$t('feedback.submittime')+'：'">
                <el-row type="flex" justify="start" align="middle">
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.startTime"
                      filterable
                      clearable
                      :placeholder="$t('public.startTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                  &emsp;<span class="time-span" style="color:#ddd;" v-show="collapse">——</span>&emsp;
                  <el-col v-show="collapse" :span="12">
                    <el-date-picker
                      v-model="listQuery.endTime"
                      filterable
                      clearable
                      :placeholder="$t('public.endTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        @click-collapse="handleCollapse"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter=true"
      @click-export="handleExport"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @row-click="rowClick"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div v-if="item.prop==='feedbackMessage'">
            <el-popover
              v-if="scope.row[item.prop]"
              placement="top-start"
              :width="300"
              trigger="hover"
              :visible-arrow="false"
              :content="scope.row[item.prop]"
            >
              <span slot="reference">{{ scope.row[item.prop] || '/' }}</span>
            </el-popover>
            <span v-if="!scope.row[item.prop]">/</span>
          </div>
          <div v-else-if="item.prop==='uriOne' || item.prop==='uriTwo' || item.prop==='uriThree'">
            <img v-if="scope.row[item.prop]" :src="scope.row[item.prop]" class="person-img-list">
            <span v-else>/</span>
          </div>
          <div v-else>
            <span>{{ scope.row[item.prop] | switchText(item.prop) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="$t('public.operation')"
        width="100px"
        align="center"
      >
        <template slot-scope="scope">
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
          <div>
            <el-button v-if="scope.row['feedbackStatus'] == 0" type="primary" size="mini" @click="handleAudit(scope.row)">
              {{ $t('feedback.process') }}
            </el-button>
            <el-button v-else-if="scope.row['feedbackStatus'] == 1" type="primary" size="mini" @click="handleAudit(scope.row)">
              {{ $t('public.view') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    
    <!-- 查看dialog弹窗 -->
    <detail-dialog
      :visibles.sync="detailVisible"
      :data="tableRow"
    />
  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// 组件

import detailDialog from './components/detailDialog'
// request
import { getPagelist, exprotHandle } from '@/api/userCenter/feedback'

export default {
  name: 'feedback',
  components: { detailDialog },
  filters: {
    switchText(val, type) {
      if (type === 'feedbackStatus') {
        return val == '0' ? vm.$t('feedback.feedbackStatusYes') : val == '1' ? vm.$t('feedback.feedbackStatusNo') : ''
      } else if (type === 'feedbackReplied') {
        return val == '1' ? vm.$t('feedback.feedbackRepliedYes') : val == '0' ? vm.$t('feedback.feedbackRepliedNo') : ''
      }else {
        return val || '/'
      }
    }
  },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      listQuery: {
        startTime: '',
        endTime: '',
        feedbackReplied: '',
        mobile: '',
        feedbackStatus:''
      },
      feedbackStatusList: [
        {text:this.$t('feedback.feedbackStatusYes'), value:'0'},
        {text:this.$t('feedback.feedbackStatusNo'), value:'1'}
      ],
      feedbackRepliedList: [
        {text:this.$t('feedback.feedbackRepliedYes'), value:'1'},
        {text:this.$t('feedback.feedbackRepliedNo'), value:'0'}
      ],
      showfilter: false,
      tableList: [
        { value: this.$t('feedback.mobile'), prop: 'mobile', sortable: 'custom', position: 'center', width: '120px', checked: true },
        // { value: this.$t('public.obdCode'), prop: 'barCode', position: 'center', width: '120px', checked: true },
        { value: this.$t('feedback.suggestionDetail'), prop: 'feedbackMessage', position: 'center', width: '320px', checked: true },
        { value: this.$t('feedback.replayStatus'), prop: 'feedbackReplied', sortable: 'custom', position: 'center', width: '170px', checked: true },
        { value: this.$t('feedback.processStatus'), prop: 'feedbackStatus', sortable: 'custom', position: 'center', width: '170px', checked: true },
        { value: this.$t('feedback.submittime'), prop: 'createdOn', sortable: 'custom', position: 'center', width: '150px', checked: true },
        // { value: this.$t('feedback.image1'), prop: 'uriOne', sortable: 'custom', position: 'center', width: '120px', checked: true },
        // { value: this.$t('feedback.image2'), prop: 'uriTwo', sortable: 'custom', position: 'center', width: '120px', checked: true },
        // { value: this.$t('feedback.image3'), prop: 'uriThree', sortable: 'custom', position: 'center', width: '120px', checked: true },  
      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      replyVisible: false,
      detailVisible:false,
      tableRow: {},
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  mounted() {
  },
  methods: {
    // 加载数据
    listLoad() {
      this.listLoading = true
      getPagelist(this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.tableRow = {}
          this.list = data.data
          this.total = data.total
        }
        this.listLoading = false
      }).catch(()=>{
         this.listLoading = false
      })
    },
    // 点击列
    rowClick(row) {
      this.tableRow = {}
      this.tableRow = row
    },
    // 导出
    handleExport() {
      exprotHandle(this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          //
        }
      })
    },
    // 明细
    handleAudit(row) {
      this.tableRow = row
      this.detailVisible = true
    },
    refreshList(){
      this.listLoad()
    }
    
    
  }
}
</script>

<style lang='scss'>
.person-img-list{
  width:50px;
  height: 50px;
}
</style>
